function DeviceEnrolleeListData() {
    this.SerialNumber = '';
    this.Id = -1;
    this.Version = 0;

    this.FirstName = '';
    this.FullName = '';
    this.LastName = '';

    this.AgentId = -1;
    this.Birthdate = new Date(-62135596800000);
    this.IsActive = false;
    this.IsAssigned = false;
    this.OrganizationId = -1;
    this.PrimaryId = '';
    this.RiskLevelId = -1;
    this.SecondaryId = '';
    this.ArchiveFlag = 'N';
    this.TimeZoneCode = '';
    this.TimeZoneId = -1;
    this.ReferralDate = new Date(-62135596800000);
    this.EnrolleeType = 1;
    this.HasVictimFlag = false;
    this.HasAssociationFlag = 0;
    this.SoberTrackDeviceFlag = 0;
    this.OffenderPayFlag = 0
}
if (typeof exports !== 'undefined') {
    module.exports = DeviceEnrolleeListData;
}